import * as React from 'react';
import { PublishTermsLoading } from './components/PublishTermsLoading';
import { SubAgentLimitExceed } from './components/SubAgentLimitExceed';
import { PublicationError } from './components/PublicationError';
import { PublicationSection } from './components/PublicationSection/PublicationSection';

export interface IPublicationProps {
  isLoading: boolean;
  isError: boolean;
  isSubagentLimitExceed: boolean;
}

export const Publication = ({ isLoading, isError, isSubagentLimitExceed }: IPublicationProps) => {
  switch (true) {
    case isLoading:
      return <PublishTermsLoading />;

    case isSubagentLimitExceed:
      return <SubAgentLimitExceed />;

    case isError:
      return <PublicationError />;

    default:
      return <PublicationSection />;
  }
};
